module.exports = __webpack_public_path__ + "img/monaco.cfb8fd6.webp";